/** Hosts that serve production; the component gallery is hidden there (spec 004). */
export const PRODUCTION_HOSTS: readonly string[] = ['arqam.siralabs.org']

/**
 * The gallery shows in development and on staging. It is decided at run time because staging
 * and production run the same image.
 */
export function galleryEnabled(hostname: string = window.location.hostname): boolean {
  return import.meta.env.DEV || !PRODUCTION_HOSTS.includes(hostname)
}
